module.exports = __webpack_public_path__ + "static/long-term-memory-971e7dd8160ace0d1e0c1d9535f41c99.webp";